import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { AnimatedSwitch } from 'react-router-transition';
import { connect } from 'react-redux';
import Breadcrumbs from './Breadcrumbs';
import Home from '../Landing/Landing';
import Login from '../Auth/Login';
import Register from '../Auth/Register';
import Settings from '../Auth/Settings';
import News from '../News/News';
import AwardsSummary from '../Awards/AwardsSummary';
import Recruitment from '../Recruitment/Recruitment';
import Roster from '../Roster/Roster';
import UnknownRoute from '../common/UnknownRoute';
import ApplicationManager from '../Applications/ApplicationManager';
import RecruitmentApplication from "../Recruitment/RecruitmentApplication";
import Dashboard from "../Dashboard/Dashboard";
import Applications from "../Applications/Applications";
import Profile from "../Auth/Profile";
import Verify from "../Auth/Verify";
import WarnVerify from "./WarnVerify";
import {authSelector} from "../redux/selectors";
import RequestReset from "../Auth/RequestReset";
import PerformReset from "../Auth/PerformReset";
import Rules from "../About/Rules";
import Ranks from "../About/Ranks";
import FAQ from "../About/FAQ";
import Chapters from "../Officer/Chapters";
import Events from "../Officer/Events";
import EventDetail from "../Officer/EventDetail";
import Quotes from "../Media/Quotes";
import Codex from "../Media/Codex";
import DKP from "../DKP/DKP";
import DKPEventDetail from "../DKP/DKPEventDetail";
import Locations from "../Officer/Locations";
import Awards from '../Officer/Awards';
import AwardDetail from '../Officer/AwardDetail';
import DKPUserProfileDetail from '../DKP/DKPUserProfileDetail';
import DKPItemDetail from '../DKP/DKPItemDetail';
import Screenshots from '../Media/Screenshots';
import Resources from '../Officer/Resources';
import DKPResourceDetail from '../DKP/DKPResourceDetail';
import ResourceDetail from '../Officer/ResourceDetail';
import CodexCreate from '../Media/CodexCreate';
import {isMobile} from 'react-device-detect';
import ActivityFeedContainer from '../ActivityFeed/ActivityFeedContainer';
import UsersOnlineContainer from '../UsersOnline/UsersOnlineContainer';

class BodyContainer extends Component {
    componentWillReceiveProps() {
        window.previousLocation = this.props.location;
    }
    render() {
        return (
            <div className={["adt-container", (this.props.leftPanelOpen) ? '' : ' hidden-left', (this.props.rightPanelOpen) ? '' : ' hidden-right'].join(' ')}>
                {(this.props.auth.loggedIn) ?(
                    <div>
                        {(!this.props.auth.currentUser.emailVerified) ?
                        (
                        <WarnVerify />
                        ) : (null)}
                        {
                        isMobile ? (
                            <div className="alert-email">
                                <span>Mobile support is currently in Beta.  Some features and layouts may not work as intended</span>
                            </div>
                            ) : null
                        }
                    </div>
                ) : (null)}
                <Breadcrumbs />
                <AnimatedSwitch
                    atEnter={{ opacity: 0 }}
                    atLeave={{ opacity: 0 }}
                    atActive={{ opacity: 1 }}
                    className="switch-wrapper"
                >
                    <Route path="/" exact component={Home} />
                    <Route path="/news/:id" exact component={News} />
                    <Route path="/news" exact component={News} />

                    <Route path="/activity" exact component={ActivityFeedContainer} />
                    <Route path="/users" exact component={UsersOnlineContainer} />

                    <Route path="/roster" exact component={Roster} />

                    <Route path="/dkp" exact component={DKP} />
                    <Route path="/dkp/standings" exact component={DKP} />
                    <Route path="/dkp/events" exact component={DKP} />
                    <Route path="/dkp/events/:id" exact component={DKPEventDetail} />
                    <Route path="/dkp/items" exact component={DKP} />
                    <Route path="/dkp/resources" exact component={DKP} />
                    <Route path="/dkp/resources/:id" exact component={DKPResourceDetail} />
                    <Route path="/dkp/standings/:id" exact render={() => (<Redirect to='/dkp/standings' />)} />
                    <Route path="/dkp/standings/:id/:section" exact component={DKPUserProfileDetail} />
                    <Route path="/dkp/items/:id" exact component={DKPItemDetail} />


                    <Route path="/about" exact render={() => (<Redirect to='/' />)} />
                    <Route path="/about/awards" exact component={AwardsSummary} />
                    <Route path="/about/rules" exact component={Rules} />
                    <Route path="/about/ranks" exact component={Ranks} />
                    <Route path="/about/faq" exact component={FAQ} />

                    <Route path="/applications/:id" exact component={ApplicationManager} />
                    <Route path="/applications" exact component={Applications} />
                    <Route path="/apply" exact component={ApplicationManager} />

                    <Route path="/recruitment/applications/:id" exact component={RecruitmentApplication} />
                    <Route path="/recruitment/applications" render={() => (<Redirect to='/recruitment' />)} />
                    <Route path="/recruitment/recruits/:id" exact component={Recruitment} />
                    <Route path="/recruitment/recruits" render={() => (<Redirect to='/recruitment' />)} />
                    <Route path="/recruitment" exact component={Recruitment} />

                    <Route path="/login" exact component={Login} />
                    <Route path="/register" exact component={Register} />
                    <Route path="/verify/:key" exact component={Verify} />
                    <Route path="/reset/:key" exact component={PerformReset} />
                    <Route path="/reset/" exact component={RequestReset} />
                    <Route path="/settings" exact component={Settings} />
                    <Route path="/profile" exact component={Profile} />
                    <Route path="/dashboard" exact component={Dashboard} />

                    <Route path="/codex/create" exact component={CodexCreate} />
                    <Route path="/codex/:id" exact component={Codex} />
                    <Route path="/codex" exact component={Codex} />
                    
                    <Route path="/quotes/:id" exact component={Quotes} />
                    <Route path="/quotes" exact component={Quotes} />
                    <Route path="/screenshots" exact component={Screenshots} />

                    <Route path="/officer/chapters" exact component={Chapters} />
                    <Route path="/officer/awards" exact component={Awards} />
                    <Route path="/officer/awards/:id" exact component={AwardDetail} />
                    <Route path="/officer/events" exact component={Events} />
                    <Route path="/officer/events/:id" exact component={EventDetail} />
                    <Route path="/officer/locations" exact component={Locations} />
                    <Route path="/officer/resources" exact component={Resources} />
                    <Route path="/officer/resources/:id" exact component={ResourceDetail} />


                    <Route component={UnknownRoute} />
                </AnimatedSwitch>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth: authSelector(state),
        leftPanelOpen: state.panel.leftPanelOpen,
        rightPanelOpen: state.panel.rightPanelOpen,
    };
};


export default connect(mapStateToProps)(BodyContainer);


// WEBPACK FOOTER //
// ./src/App/BodyContainer.js